import React from 'react';
import Script from 'next/script';

const TrustPilotSnippet = () => {
  return (
    <>
      <Script
        type="text/javascript"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
      ></Script>
    </>
  );
};

export default TrustPilotSnippet;
